// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ReviewButton_buttonContainer__JE6IE","reviewButton":"ReviewButton_reviewButton__cGRbu"};